import { render, staticRenderFns } from "./CommentView.vue?vue&type=template&id=f01f596c&lang=pug&"
import script from "./CommentView.vue?vue&type=script&lang=ts&"
export * from "./CommentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports